// The iPhone Home Screen, as on Sylvester's phone: two pages of apps and the dock, with Notes
// (which holds the resume) in the dock in place of Camera.
// `badge`: the notification count shown on the icon. `action`: what opening the app does here,
// "resume" (Notes), "phone", "messages" (those apps), "email" or "linkedin"; any other app shows a
// hint. Names aren't shown (the Home Screen
// uses large icons without labels); Search and screen readers use them.
import safari from "../assets/icons/ios/safari.png";
import phone from "../assets/icons/ios/phone.png";
import messages from "../assets/icons/ios/messages.png";
import notes from "../assets/icons/ios/notes.png";

const icons = require.context("../assets/icons/phone", false, /\.webp$/);
const icon = (file) => icons(`./${file}.webp`);

// One page: 24 apps in rows of four, each [name, badge, action, icon], by position. The icon is
// cut from a screenshot of the phone unless given (Apple's apps use crisper art from macOS).
const page = (n, apps) =>
  apps.map(([name, badge, action, art], i) => ({
    id: `p${n}-${i + 1}`,
    name,
    icon: art || icon(`p${n}-${String(i + 1).padStart(2, "0")}`),
    badge,
    action,
  }));

export const PAGES = [
  page(1, [
    ["Reddit", "4"],
    ["Gmail", "329", "email"],
    ["Netflix", "1"],
    ["Ecobank"],
    ["Real"],
    ["Microsoft Authenticator"],
    ["Google Authenticator"],
    ["YouTube", "6,619"],
    ["Uber"],
    ["Safari", null, null, safari],
    ["Discord", "1,579"],
    ["TikTok", "11"],
    ["Shazam"],
    ["Bolt"],
    ["Yango"],
    ["Wise"],
    ["MyMTN"],
    ["Fidelity Bank Ghana"],
    ["FotMob"],
    ["Nobodies"],
    ["Tweeload"],
    ["SimCity", "1"],
    ["Okta Verify"],
    ["Revelo Go"],
  ]),
  page(2, [
    ["Google Maps"],
    ["Google Photos", "1"],
    ["Bolt Food"],
    ["ChatGPT"],
    ["Teams", "20"],
    ["TestFlight"],
    ["Golly Express"],
    ["bitchat"],
    ["PowerApp"],
    ["LinkedIn", "20", "linkedin"],
    ["Bamboo"],
    ["Preview"],
    ["Games"],
    ["BlackHole"],
    ["CalBank App"],
    ["Google Keep"],
    ["MoMo"],
    ["Twingate"],
    ["Claude"],
    ["GhanaPostGPS"],
    ["Opticash"],
    ["Temu", "48"],
    ["Binance"],
    ["Babbel"],
  ]),
];

export const DOCK = [
  { id: "dock-phone", name: "Phone", icon: phone, action: "phone" },
  { id: "dock-messages", name: "Messages", icon: messages, badge: "965", action: "messages" },
  { id: "dock-notes", name: "Notes", icon: notes, action: "resume" },
  { id: "dock-chrome", name: "Chrome", icon: icon("chrome"), action: "chrome" },
];
